import React from 'react'
import NavBarHome from '../../components/NavBar/NavBarHome'
import Footer from '../../components/Footer/Footer'

function CookiePage() {
  return (
    <div className="pt-[92px] flex flex-col min-h-screen">
         <NavBarHome />

         <Footer
            logo={"/Logo NextMaker.png"}
            bgColor="bg-dark-1"
            textColor="text-gray-100"
            borderColor="border-gray-400/20"
         />
      </div>
  )
}

export default CookiePage